import React from 'react';
import Typography from '@mui/material/Typography';
import styled from '@emotion/styled';
import { getLanguage } from 'translation';

const Background = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.backgroundNeutral.main
}));

const ContentBackground = styled('section')(({ theme }) => ({
  borderBottom: `3px solid ${theme.palette.primary.main}`
}));

const FlexContent = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  ...theme.wrapper,
  maxWidth: 820,
  gap: 15,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column'
  }
}));

const CoFoundWrapper = styled('div')(({ theme }) => ({
  padding: '80px 100px',
  ...theme.wrapper,
  [theme.breakpoints.down('lg')]: {
    padding: 50
  },
  [theme.breakpoints.down('md')]: {
    padding: 30
  },
  [theme.breakpoints.down('sm')]: {
    padding: 20
  }
}));

const StyledSubtitle = styled(Typography)(() => ({
  fontSize: 21,
  lineHeight: '35px',
  marginBottom: 35
}));

const GreenCard = styled('div')(({ theme }) => ({
  backgroundColor: 'rgba(185, 248, 51, 1)',
  padding: '50px 60px',
  borderRadius: 20,
  alignContent: 'center',
  [theme.breakpoints.down('md')]: {
    padding: '30px 40px'
  }
}));

const CardTitle = styled(Typography)(({ theme }) => ({
  fontSize: 30,
  lineHeight: '40px',
  color: theme.palette.grey[600],
  textAlign: 'center',
  marginBottom: 20,
  fontWeight: 500
}));

const CardText = styled(Typography)(({ theme }) => ({
  fontSize: 21,
  color: theme.palette.grey[600],
  textAlign: 'center'
}));

const FlexCards = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(2, 1fr)`,
  gap: 15,
  ...theme.wrapper,
  maxWidth: 820,
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
    gap: 15
  }
}));

const GreenCards = ({ texts }) => {
  const [lang] = React.useState(() => getLanguage());

  return (
    <ContentBackground>
      <Background>
        <CoFoundWrapper>
          <FlexContent>
            <StyledSubtitle variant="h3">{texts?.method_headline?.[lang]}</StyledSubtitle>
          </FlexContent>

          <FlexCards>
            <GreenCard>
              <CardTitle>{texts?.method_value_1_header?.[lang]}</CardTitle>
              <CardText>{texts?.method_value_1_text?.[lang]}</CardText>
            </GreenCard>

            <GreenCard>
              <CardTitle>{texts?.method_value_2_header?.[lang]}</CardTitle>
              <CardText>{texts?.method_value_2_text?.[lang]}</CardText>
            </GreenCard>

            <GreenCard>
              <CardTitle>{texts?.method_value_3_header?.[lang]}</CardTitle>
              <CardText>{texts?.method_value_3_text?.[lang]}</CardText>
            </GreenCard>

            <GreenCard>
              <CardTitle>{texts?.method_value_4_header?.[lang]}</CardTitle>
              <CardText>{texts?.method_value_4_text?.[lang]}</CardText>
            </GreenCard>
          </FlexCards>
        </CoFoundWrapper>
      </Background>
    </ContentBackground>
  );
};

export default GreenCards;
